import {
  //APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './application.routes';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { environment } from '@environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { CommunityEffects, communityReducers, communityStateKey } from '@redux/community.effects';
import {
  AuthenticationEffects,
  authenticationReducer,
  authenticationStateKey,
} from '@redux/authentication.redux';
import { authenticatedInterceptor } from './core/interceptors/authenticated.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { NgxSpinnerModule } from 'ngx-spinner';
import { unauthenticatedInterceptor } from './core/interceptors/unauthenticated.interceptor';
import { CatalogEffects, catalogReducer, catalogStateKey } from '@redux/catalog.redux';
import {
  CrosscuttingEffects,
  crosscuttingReducer,
  crosscuttingStateKey,
} from '@redux/crosscutting.redux';
import {
  AnnouncementsEffects,
  announcementsReducers,
  announcementsStateKey,
} from '@redux/announcements.effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { DiningEffects, diningReducers, diningStateKey } from '@redux/dining.effects';
import { GalleryEffects, galleryReducers, galleryStateKey } from '@redux/gallery.effects';
import { ApplicationState, metaReducers } from '@redux/clear.redux';
import { ResidentsEffects, residentsReducers, residentsStateKey } from '@redux/directory.effects';
import { DocumentEffects } from '@redux/document.effects';

import { SurveysEffects, surveysReducers, surveysStateKey } from '@redux/surveys.effects';
import { EventsEffects, eventsReducers, eventsStateKey } from '@redux/events.effects';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';

import { getDatabase, provideDatabase } from '@angular/fire/database';
import { BsModalService } from 'ngx-bootstrap/modal';
import { getMessaging, provideMessaging } from '@angular/fire/messaging';
import { UserEffects, userReducers, userStateKey } from '@redux/user.effects';
import {
  NotificationsEffects,
  notificationsReducer,
  notificationsStateKey,
} from '@redux/notifications.redux';
import {
  ServiceRequestsEffects,
  serviceRequestsReducers,
  serviceRequestsStateKey,
} from '@redux/service-requests.effects';
import {
  CorporationEffects,
  corporationReducer,
  corporationStateKey,
} from '@redux/corporation.effects';
import { AnnouncementsService } from './features/announcements/services/announcements.service';

export const applicationConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      BrowserModule,
      BrowserAnimationsModule,
      ToastrModule.forRoot({
        timeOut: 5000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
      }),
      SweetAlert2Module.forRoot(),
      NgxSpinnerModule.forRoot({
        type: 'ball-scale-multiple'
      }),
    ),
    provideHttpClient(withInterceptors([authenticatedInterceptor, unauthenticatedInterceptor])),
    provideStore<ApplicationState>(
      {
        [communityStateKey]: communityReducers,
        [authenticationStateKey]: authenticationReducer,
        [catalogStateKey]: catalogReducer,
        [crosscuttingStateKey]: crosscuttingReducer,
        [announcementsStateKey]: announcementsReducers,
        [galleryStateKey]: galleryReducers,
        [diningStateKey]: diningReducers,
        [residentsStateKey]: residentsReducers,
        [notificationsStateKey]: notificationsReducer,
        [surveysStateKey]: surveysReducers,
        [eventsStateKey]: eventsReducers,
        [userStateKey]: userReducers,
        [serviceRequestsStateKey]: serviceRequestsReducers,
        [corporationStateKey]: corporationReducer,
        // [documentStateKey] : documentReducers TODO
      },
      { metaReducers },
    ),
    provideEffects([
      CommunityEffects,
      AuthenticationEffects,
      CatalogEffects,
      CrosscuttingEffects,
      AnnouncementsEffects,
      DiningEffects,
      GalleryEffects,

      ResidentsEffects,
      NotificationsEffects,
      SurveysEffects,
      EventsEffects,
      UserEffects,
      DocumentEffects,
      ServiceRequestsEffects,
      CorporationEffects,
    ]),
    provideStoreDevtools({
      maxAge: 25, // Mantén solo las últimas 25 acciones
      logOnly: environment.production, // Solo log en modo no producción
      trace: true,
    }),
    provideRouter(routes),

    { provide: 'API_URL', useValue: environment.server.api },
    //
    // Inicialización de Firebase
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideDatabase(() => getDatabase()),
    provideMessaging(() => getMessaging()),
    BsModalService,
    AnnouncementsService,
  ],
};
